import { createVueApp, SentryTracking, setupI18n } from '@hfc/ui-core';
import { appConfig } from '../AppConfig';
import App from '@/App.vue';
import '@hfc/ui-core/dist/index.css';
import '@/shared/infrastructure/main.css';
import '@/shared/infrastructure/Validations';
import i18nEn from '@/shared/i18n/en.json';
import i18nEs from '@/shared/i18n/es.json';
import 'vue-multiselect/dist/vue-multiselect.css';
import { vMaska } from 'maska/vue';
import { AppStore } from '@/shared/infrastructure/store/AppStore';
import { MedicareConsentStore } from '@/consent/medicare/infrastructure/store/MedicareConsentStore';
import { QuoteStore } from '@/quote/infrastructure/store/QuoteStore';
import { PlanStore } from '@/planList/infrastructure/store/PlanStore';
import { SmallBusinessStore } from '@/application/smallBusiness/infrastructure/store/SmallBusinessStore';
import { DentalAndVisionApplicationStore } from '@/application/shared/infrastructure/store/DentalAndVisionApplicationStore';
import { ComparePlansStore } from '@/shared/infrastructure/store/ComparePlansStore';

setupI18n({ 'en-US': i18nEn, 'es-US': i18nEs });

const app = await createVueApp(App, appConfig);
const sentry = new SentryTracking(appConfig.tracking, app);

sentry.init();

app.provide('AppStore', new AppStore());
app.provide('MedicareConsentStore', new MedicareConsentStore());
app.provide('QuoteStore', new QuoteStore());
app.provide('PlanStore', new PlanStore());
app.provide('SmallBusinessStore', new SmallBusinessStore());
app.provide('DentalAndVisionApplicationStore', new DentalAndVisionApplicationStore());
app.provide('ComparePlansStore', new ComparePlansStore());

app.directive('maska', vMaska);

app.mount('#app');
